import type { SupportedLocale } from "./locales";

const loaders = {
  ar: () => import("./verbleif-frontend-ar.json"),
  bg: () => import("./verbleif-frontend-bg.json"),
  cs: () => import("./verbleif-frontend-cs.json"),
  de: () => import("./verbleif-frontend-de.json"),
  en: () => import("./verbleif-frontend-en.json"),
  es: () => import("./verbleif-frontend-es.json"),
  fr: () => import("./verbleif-frontend-fr.json"),
  hu: () => import("./verbleif-frontend-hu.json"),
  it: () => import("./verbleif-frontend-it.json"),
  nl: () => import("./verbleif-frontend-nl.json"),
  pl: () => import("./verbleif-frontend-pl.json"),
  pt: () => import("./verbleif-frontend-pt.json"),
  ro: () => import("./verbleif-frontend-ro.json"),
  ru: () => import("./verbleif-frontend-ru.json"),
  sk: () => import("./verbleif-frontend-sk.json"),
  tr: () => import("./verbleif-frontend-tr.json"),
  uk: () => import("./verbleif-frontend-uk.json"),
} satisfies Record<SupportedLocale, () => Promise<{ default: object }>>;

export function loadLocaleCatalog(code: SupportedLocale): Promise<object> {
  return loaders[code]().then(mod => mod.default);
}
